import { IMetricData, IMetricDataPairs } from '../components/OverallMetricsV2/interfaces';

export interface SenseiPageParams {
  commitmentTable: ICommitmentTable;
  ptpDetailTable: IPtpDetailsTable;
  outputTable: IOutputTable;
  inputTable: InputTable;
  OverallMetricTable: IOverallMetricTableParams;
}

export interface IOverallMetricTableParams {
  pageIndex: number;
  pageSize: number;
  sortBy: string;
  sortDirection: string;
  caseBucket: string;
  teamLeadReferenceId: string;
  showTrainingAgents: string;
}

export interface IOutputTable {
  outputTableSortKey: string;
  outputTableSortOrder: string;
  currentPage: string;
  pageNumber: string;
  pageSize: string;
  filterSelected: string;
}

export interface InputTable {
  inputTableSortKey: string;
  inputTableSortOrder: string;
  currentPage: string;
  pageNumber: string;
  pageSize: string;
  filterSelected: string;
}

export interface ICommitmentTable {
  currentPage: string;
  date: string;
  pageNumber: string;
  pageSize: string;
}

export interface IPtpDetailsTable {
  date: string;
  agentId: string;
  pageNumber: string;
  pageSize: string;
  currentPage: string;
  ptpStatus: string;
}

export interface IUpdateCommitment {
  data: any;
  commitmentReferenceId: string;
}

export interface ISenseiPageState {
  dailyPlanning: IDailyPlanning;
  overallMetrics: IOverallMetrics;
}

export interface IMetricGrouping {
  metricGroupLabel: string;
  metricKeyList: Array<keyof IMetricDataPairs>;
}

interface ISelectedMetricData {
  agentName: string;
  data: IMetricData | null;
  agentSummaryMetricKeys: Array<keyof IMetricDataPairs>;
  metricGrouping: IMetricGrouping[];
  lastUpdatedAt: string;
}

export interface IOverallMetrics {
  inputTable: IInputTable;
  outputTable: IOutputTable;
  metricTableV2: IMetricTableV2;
  selectedAgentMetrics: {
    data: ISelectedMetricData;
    loading: boolean;
  };
}

export interface IInputTable {
  data: any[];
  pages: IPages;
  loading: boolean;
  lastUpdatedAt: number;
}

export interface IOutputTable {
  data: OutputData[];
  pages: IPages;
  loading: boolean;
  filters: {
    dpdBucket: DpdBucketEntity[];
  };
  lastUpdatedAt: number;
}

export interface IMetricTableV2 {
  data: IMetricData[];
  pages: IPages;
  loading: boolean;
  filters: {
    caseBucket: DpdBucketEntity[];
    teamLeadReferenceId: DpdBucketEntity[];
    showTrainingAgents: string;
  };
  lastUpdatedAt: number;
  metricGrouping: IMetricGrouping[];
  agentSummaryMetricKeyList: Array<keyof IMetricDataPairs>;
}

export interface IAgencyFilter {
  label: string;
  value: string;
}

export interface ITeamLeadFilter {
  label: string;
  additionalData: {
    agencyCode: string;
  };
  value: string;
}

export interface IDailyPlanning {
  filters: {
    loading: boolean;
    agencies: IAgencyFilter[];
    teamLeads: ITeamLeadFilter[];
  };
  commitmentsTable: ICommitmentsTable;
  ptpDetailsTable: IPtpDetailsTableData;
}

interface ICommitmentsTable {
  data: ICommitment[];
  pages: IPages;
  loading: boolean;
  reasons: IReasons;
  lastUpdatedAt: number;
}

export interface IReasons {
  cashDeviation: string[];
  visitDeviation: string[];
}

export interface IPages {
  pageNo: number;
  pageSize: number;
  totalPages: number;
  totalElements: number;
}

export interface ICommitment {
  commitmentReferenceId: string;
  agentName: string;
  cashCollected: number;
  cashCommitted: number | null;
  visitsCommitted: number | null;
  visits: number;
  ptpsDue: number;
  requiredDrr: number;
  firstFeedback: string;
  lastFeedback: string;
  reasonsForCashDeviation: string[];
  reasonsForVisitDeviation: string[];
  agentReferenceId: string;
  reasonsEditable: boolean;
  remarks: string;
}

export type commitmentKeys = keyof ICommitment;

export interface IPtpDetailsTableData {
  data: IPtpDetail[];
  pages: IPages;
  loading: boolean;
  filters: IPtpDetailsFilters;
  lastUpdatedAt: number;
}

export interface IPtpDetailsFilters {
  agents: AgentFilters[];
  ptpStatus: AgentFilters[];
}

interface AgentFilters {
  label: string;
  value: string;
}
export interface IPtpDetail {
  customerName: string;
  accountNumber: string;
  agentName: string;
  dpdBucket: string;
  emi: number;
  overdueAmount: number;
  ptpAmount: number;
  ptpTime: string;
  ptpType: string;
  pastPtpBroken: string;
  visitFeedback: string;
  callFeedback: string;
}

export interface filtersNames {
  agentName: string;
  agentReferenceId: string;
}

export interface Output {
  performanceData: IOutputData;
  lastUpdatedAt: number;
  filter: Filter;
}
export interface IOutputData {
  data?: OutputData[] | null;
  pages: Pages;
}
export interface OutputData {
  agentReferenceId: string;
  agentName: string;
  phoneNumber: string;
  performanceLevel: number;
  overallTarget: number;
  allocatedCases: number;
  overallCashCollected: number;
  overallAchievementPercent: number;
  accountsWithAtleastOneEmiCollected: number;
  accountsWithPartiallyPaidEmi: number;
  ptpConversionPercent: number;
}
export interface Pages {
  pageNo: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}
export interface Filter {
  dpdBucket?: DpdBucketEntity[] | null;
}
export interface DpdBucketEntity {
  label: string;
  value: string;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}
